import { ActionTypesScreen5 } from "app/constants";

export const defaultState = {
  listData: [],
  objectData: {},
  singleData: null,
};

function Screen5Reducer(state = defaultState, action) {
  switch (action.type) {
    case ActionTypesScreen5.UPDATE_OCCUPATION_TYPE_SCREEN5:
      return { ...state, occupationType: action.payload };
    case ActionTypesScreen5.GET_OCCUPATION_DATA_SCREEN5:
      return { ...state, occupationDataScreen5: action.payload };
    case ActionTypesScreen5.GET_AVERAGE_DATA_SCREEN5:
      return { ...state, averageDataScreen5: action.payload };
    case ActionTypesScreen5.GET_INCOME_DATA_SCREEN5:
      return { ...state, incomeDataScreen5: action.payload };
    case ActionTypesScreen5.GET_INCOME_DIFF_DATA_SCREEN5:
      return { ...state, incomeDiffDataScreen5: action.payload };
    case ActionTypesScreen5.GET_AGE_DATA_SCREEN5:
      return { ...state, ageDataScreen5: action.payload };
    case ActionTypesScreen5.GET_RACE_DATA_SCREEN5:
      return { ...state, raceDataScreen5: action.payload };
    case ActionTypesScreen5.GET_GENDER_DATA_SCREEN5:
      return { ...state, genderDataScreen5: action.payload };
    default:
      return state;
  }
}

export default Screen5Reducer;
